import { useCallback, MouseEvent } from 'react'
import { HierarchicalMenu as Categories } from 'react-instantsearch'
import { Stack, Text } from '@leroy-merlin-br/backyard-react'

import { Accordion } from 'scripts/react-components/site/EntryKey/components'

import { Card } from 'site/AlgoliaEntryKey/components'
import { onFilterDataLayer } from 'site/AlgoliaEntryKey/utils/data-layer'
import { useAlgoliaContext } from 'site/AlgoliaEntryKey/context/algolia-context'

import * as S from './styled'

interface HierarchicalMenuProps {
  filterIndex: number
  isMobile?: boolean
}

const HierarchicalMenu = ({ filterIndex, isMobile }: HierarchicalMenuProps) => {
  const { gaTrack, pageType, query } = useAlgoliaContext()

  const handleClick = useCallback(
    (event: MouseEvent<HTMLDivElement>) => {
      const value = (event.target as HTMLDivElement).textContent ?? ''
      const url = new URL(window.location.href)

      onFilterDataLayer({
        gaTrack,
        term: query,
        pageType,
        filter: 'Normal',
        filterType: {
          index: filterIndex,
          value: 'hierarchicalCategories.lvl0'
        },
        filterElement: { index: 0, value },
        isParamAlreadySet: url.searchParams.has(value)
      })
    },
    [filterIndex, gaTrack, pageType, query]
  )

  const renderHierarquicalMenu = () => (
    <Categories
      attributes={[
        'hierarchicalCategories.lvl0',
        'hierarchicalCategories.lvl1',
        'hierarchicalCategories.lvl2',
        'hierarchicalCategories.lvl3'
      ]}
      limit={isMobile ? 10 : 5}
      onClick={handleClick}
      sortBy={['count:desc']}
      showMore={!isMobile}
      showMoreLimit={10}
      translations={{
        showMoreButtonText({ isShowingMore }) {
          return isShowingMore ? 'Ver menos' : 'Ver mais'
        }
      }}
    />
  )

  return (
    <S.Wrapper>
      {isMobile ? (
        <Accordion title="Departamento">{renderHierarquicalMenu()}</Accordion>
      ) : (
        <S.Wrapper>
          <Card target="card">
            <Stack space="bit">
              <Text as="div" size="giga" isBold noMargin>
                Departamento
              </Text>
              {renderHierarquicalMenu()}
            </Stack>
          </Card>
        </S.Wrapper>
      )}
    </S.Wrapper>
  )
}

export default HierarchicalMenu
